import { render, staticRenderFns } from "./PmuDataSheetsList.vue?vue&type=template&id=4c22d48c"
import script from "./PmuDataSheetsList.vue?vue&type=script&lang=js"
export * from "./PmuDataSheetsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports